import axios from "axios";

function sendJourneyFlowId(params) {
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };
  return axios.get(
    `${process.env.VUE_APP_BASE_URL}/api/check_image_qr_compliance_status_in_pre_registration/${params}`,
    {
      headers: headers,
    }
  );
}

function uploadeImage(params) {
  const user = JSON.parse(localStorage.getItem("user"));
  return axios.post(
    `${process.env.VUE_APP_BASE_URL}/api/change-image`,
    params,
    {
      headers: {
        Accept: "*",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${user.data.access_token}`,
      },
    }
  );
}
function getAreaDetails(params) {
  const user = JSON.parse(localStorage.getItem("user"));
  const headers = {
    Accept: "*",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: `Bearer ${user.data.access_token}`,
  };
  return fetch(`${process.env.VUE_APP_BASE_URL}/api/areas/${params}`, {
    method: "GET",
    headers: headers,
  });
}

export default {
  sendJourneyFlowId,
  uploadeImage,
  getAreaDetails,
};
